/**
 * GEN78 — "İndirime göre sırala" + ürün kartı carousel'i
 * ---------------------------------------------------------------------------
 * Shopify'da indirim oranına göre bir sort_by değeri yok ve Liquid içinde
 * 50'den fazla ürün sunucu tarafında sıralanamıyor. Bu yüzden:
 *
 *   1. Her kart sıralama katmanlarını data-* olarak taşır: data-discount,
 *      data-sort-price, data-sort-title (snippets/product-item.liquid).
 *   2. templates/{collection,search}.discount-sort.liquid layout'suz, sadece
 *      kartlardan oluşan hafif bir çıktı verir (sayfa başına 50 ürün).
 *   3. Bu dosya o endpoint'in tüm sayfalarını çeker, kartları üç katmanlı
 *      sıralar (bkz. compareCards) ve grid'i tarayıcıda yeniden dizer;
 *      sayfalamayı da kendi "daha fazla göster" butonuyla yönetir.
 *
 * theme.js / theme.min.js hiç değiştirilmedi — entegrasyon tamamen DOM ve
 * capture fazı event'leri üzerinden.
 *
 * Ayrıca: kart carousel'i eskiden her kart için inline <script> ile
 * DOMContentLoaded'a bağlanıyordu. AJAX ile sonradan enjekte edilen kartlarda
 * bu hiç çalışmıyordu (innerHTML script çalıştırmaz, DOMContentLoaded bir daha
 * tetiklenmez). Artık event delegation ile kurulduğu için her kartta çalışır.
 */
(function () {
  'use strict';

  var SORT_VALUE = 'discount-descending';
  var VIEW = 'discount-sort';
  var CONCURRENCY = 4;

  /* =========================================================================
     Kart carousel'i (delegation) — her sayfada çalışır
     ========================================================================= */

  function carouselFor(el) {
    var wrap = el.closest('.gen78-card__image-wrap');
    return wrap ? wrap.querySelector('.gen78-card__carousel') : null;
  }

  function syncCarousel(carousel) {
    var wrap = carousel.closest('.gen78-card__image-wrap');
    if (!wrap) return;

    var width = carousel.offsetWidth || 1;
    var index = Math.round(carousel.scrollLeft / width);
    var maxIndex = carousel.children.length - 1;

    var dots = wrap.querySelectorAll('.gen78-card__dots .gen78-dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }

    var prev = wrap.querySelector('.gen78-card__nav--prev');
    var next = wrap.querySelector('.gen78-card__nav--next');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= maxIndex;
  }

  function syncCarousels(root) {
    var carousels = (root || document).querySelectorAll('.gen78-card__carousel');
    for (var i = 0; i < carousels.length; i++) syncCarousel(carousels[i]);
  }

  function initCarousels() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('.gen78-card__nav');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var carousel = carouselFor(btn);
      if (!carousel) return;

      var direction = btn.classList.contains('gen78-card__nav--next') ? 1 : -1;
      carousel.scrollBy({ left: direction * carousel.offsetWidth, behavior: 'smooth' });
    });

    // scroll bubble etmez — capture fazında tek dinleyici yeterli.
    document.addEventListener(
      'scroll',
      function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('gen78-card__carousel')) syncCarousel(t);
      },
      true
    );

    syncCarousels(document);
  }

  /* =========================================================================
     İndirime göre sıralama
     ========================================================================= */

  /**
   * Ürün adı karşılaştırması, sayfanın diline göre. Türkçede ç/ğ/ı/ö/ş/ü
   * sıralaması ASCII'den farklı olduğu için düz `<` yeterli değil.
   * numeric:true → "Model 2" < "Model 10".
   */
  var collator = (function () {
    if (!window.Intl || !Intl.Collator) return null;
    var options = { numeric: true, sensitivity: 'base' };
    try {
      return new Intl.Collator(document.documentElement.lang || undefined, options);
    } catch (e) {
      // Geçersiz lang attribute'u tüm dosyayı (carousel dahil) düşürmesin.
      return new Intl.Collator(undefined, options);
    }
  })();

  function compareTitles(a, b) {
    if (a === b) return 0;
    if (collator) return collator.compare(a, b);
    return a < b ? -1 : 1;
  }

  /**
   * Sıralama katmanları (müşteri talebi):
   *   1. indirim oranı  — büyükten küçüğe (indirimsizler 0 alır, sona düşer)
   *   2. fiyat          — aynı orandakiler kendi içinde pahalıdan ucuza
   *   3. ürün adı       — aynı fiyattakiler A→Z
   *   4. (eşitlik bozucu) koleksiyonun sunucudan gelen sırası — sıralamanın
   *      her yüklemede birebir aynı olması için.
   *
   * Fiyat kuruş cinsinden tam sayı; eksik/bozuk attribute 0 sayılır.
   */
  function compareCards(a, b) {
    return (
      b.discount - a.discount ||
      b.price - a.price ||
      compareTitles(a.title, b.title) ||
      a.i - b.i
    );
  }

  function cardEntry(el, i) {
    return {
      el: el,
      i: i,
      discount: parseFloat(el.getAttribute('data-discount')) || 0,
      price: parseFloat(el.getAttribute('data-sort-price')) || 0,
      title: el.getAttribute('data-sort-title') || ''
    };
  }

  var state = {
    active: false,
    shown: 0,
    perPage: 24,
    paginationType: 'infinite',
    sorted: null,
    observer: null,
    io: null,
    busy: false
  };

  var cache = {};

  function context() {
    var partial = document.querySelector('[data-partial]');
    if (!partial) return null;

    var grid =
      partial.querySelector('.collection__infinite-container') ||
      partial.querySelector('.search__infinite-container');
    if (!grid) return null;

    var isSearch = grid.classList.contains('search__infinite-container');

    return {
      partial: partial,
      grid: grid,
      isSearch: isSearch,
      trigger: partial.querySelector(
        isSearch ? '.search__infinite-trigger' : '.collection__infinite-trigger'
      ),
      loader: document.querySelector(isSearch ? '.search__loading' : '.collection__loading')
    };
  }

  function urlHasSort() {
    return new URLSearchParams(window.location.search).get('sort_by') === SORT_VALUE;
  }

  /** Endpoint'e gönderilecek parametreler: filtreler ve arama terimi korunur. */
  function baseParams() {
    var params = new URLSearchParams(window.location.search);
    ['sort_by', 'page', 'view', 'section_id'].forEach(function (key) {
      params.delete(key);
    });
    return params;
  }

  function fetchPage(params, page) {
    var query = new URLSearchParams(params.toString());
    query.set('view', VIEW);
    query.set('page', String(page));

    return fetch(window.location.pathname + '?' + query.toString(), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var wrapper = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-gen78-sort-page]');

        // Şablon yayınlanmamışsa Shopify varsayılan şablona düşer ve bu marker olmaz.
        if (!wrapper) throw new Error('discount-sort view template not found');
        return wrapper;
      });
  }

  /** Sırayla değil, en fazla `limit` istek eşzamanlı. */
  function runQueue(items, limit, worker) {
    var index = 0;

    function next() {
      if (index >= items.length) return Promise.resolve();
      var item = items[index++];
      return worker(item).then(next);
    }

    var runners = [];
    for (var i = 0; i < Math.min(limit, items.length); i++) runners.push(next());
    return Promise.all(runners);
  }

  function loadSorted(params) {
    var key = window.location.pathname + '?' + params.toString();
    if (cache[key]) return Promise.resolve(cache[key]);

    return fetchPage(params, 1).then(function (first) {
      var pages = parseInt(first.getAttribute('data-pages'), 10) || 1;
      var wrappers = [first];
      var remaining = [];
      for (var page = 2; page <= pages; page++) remaining.push(page);

      return runQueue(remaining, CONCURRENCY, function (page) {
        return fetchPage(params, page).then(function (wrapper) {
          wrappers[page - 1] = wrapper;
        });
      }).then(function () {
        var cards = [];
        wrappers.forEach(function (wrapper) {
          if (!wrapper) return;
          var items = wrapper.querySelectorAll('.product-item');
          for (var i = 0; i < items.length; i++) cards.push(items[i]);
        });

        var sorted = cards
          .map(cardEntry)
          .sort(compareCards)
          .map(function (entry) {
            return entry.el;
          });

        cache[key] = sorted;
        return sorted;
      });
    });
  }

  /* ---------------------------------------------------------------- render */

  /** Kendi DOM yazmalarımız MutationObserver'ı tetiklemesin. */
  function unobserved(callback) {
    var observer = state.observer;
    if (observer) observer.disconnect();
    try {
      callback();
    } finally {
      if (observer) {
        observer.takeRecords();
        observe();
      }
    }
  }

  function loadMoreLabel() {
    var label = window.gen78 && window.gen78.strings && window.gen78.strings.loadMore;
    return label || 'Load more';
  }

  function updateCount(ctx, total) {
    var el = ctx.partial.querySelector('[data-pagination-item-count]');
    var strings = window.theme && window.theme.strings && window.theme.strings.pagination;
    if (!el || !strings || !strings.viewing) return;

    var noun = (ctx.isSearch ? strings.results : strings.products) || '';
    el.innerHTML =
      strings.viewing.replace('{{ of }}', '1-' + state.shown).replace('{{ total }}', total) +
      ' ' +
      noun;
  }

  /**
   * Kendi "devamını yükle" kabımız.
   *
   * Temanın .collection__infinite-trigger / .search__infinite-trigger kabını
   * KULLANMIYORUZ: theme.css onu `display:none` yapıyor ve sadece
   * .collection--pagination-click gövdesinde gösteriyor. Yani infinite ve
   * paginated modlarda o kabın içine konan hiçbir şey görünmez.
   */
  function ensureMoreHolder(ctx) {
    var holder = ctx.partial.querySelector('.gen78-sort-more');
    if (holder && holder.isConnected) return holder;

    holder = document.createElement('div');
    holder.className = 'gen78-sort-more';
    ctx.grid.parentNode.insertBefore(holder, ctx.grid.nextSibling);
    return holder;
  }

  function disconnectScrollLoader() {
    if (state.io) {
      state.io.disconnect();
      state.io = null;
    }
  }

  /**
   * Sunucunun "load more" linkini temizler — Ajaxinate her kontrolde trigger
   * içinde <a> arar, bulamazsa devre dışı kalır. Böylece sunucu sıralamasıyla
   * ürün eklemesi engellenir. Kendi kontrolümüz section ayarını takip eder:
   *   - infinite  : görünmez sentinel + IntersectionObserver (otomatik yükleme)
   *   - click     : "daha fazlasını yükle" butonu
   *   - paginated : buton — numaralı sayfalama sıralı listede çalışamıyor
   *                 (?page=2 sunucudan varsayılan sırayla gelir), ama satıcı
   *                 sayfalı gezinme seçtiği için otomatik yüklemeye çevirmiyoruz.
   */
  function renderMoreControl(ctx) {
    if (ctx.trigger) ctx.trigger.innerHTML = '';

    disconnectScrollLoader();

    var holder = ensureMoreHolder(ctx);
    holder.innerHTML = '';
    if (state.shown >= state.sorted.length) return;

    var autoLoad = state.paginationType === 'infinite' && 'IntersectionObserver' in window;

    if (autoLoad) {
      var sentinel = document.createElement('div');
      sentinel.className = 'gen78-sort-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      holder.appendChild(sentinel);

      // Callback asenkron olduğu için appendMore -> renderMoreControl zinciri
      // özyineleme yapmaz; sentinel hâlâ görünürse bir sonraki grup yüklenir.
      state.io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              appendMore(ctx);
              return;
            }
          }
        },
        { rootMargin: '600px 0px' }
      );
      state.io.observe(sentinel);
      return;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--secondary no-transition';
    button.textContent = loadMoreLabel();
    button.addEventListener('click', function () {
      appendMore(ctx);
    });
    holder.appendChild(button);
  }

  function paint(ctx, from, to, replace) {
    var fragment = document.createDocumentFragment();
    for (var i = from; i < to; i++) fragment.appendChild(state.sorted[i].cloneNode(true));
    state.shown = to;

    unobserved(function () {
      if (replace) ctx.grid.innerHTML = '';
      ctx.grid.appendChild(fragment);
      ctx.partial.classList.add('gen78-sorted');
      renderMoreControl(ctx);
      updateCount(ctx, state.sorted.length);
    });

    syncCarousels(ctx.grid);
  }

  function appendMore(ctx) {
    // Kuyruğa girmiş bir IntersectionObserver callback'i, sıralama kapandıktan
    // veya liste sıfırlandıktan sonra da çalışabilir.
    if (!state.active || !state.sorted || state.busy) return;
    paint(ctx, state.shown, Math.min(state.shown + state.perPage, state.sorted.length), false);
  }

  function setBusy(ctx, busy) {
    state.busy = busy;
    ctx.partial.classList.toggle('gen78-sorting', busy);
    if (ctx.loader) ctx.loader.classList.toggle('is-active', busy);
  }

  /* ------------------------------------------------------------- lifecycle */

  function apply(ctx) {
    setBusy(ctx, true);
    // Yeniden çekim sürerken eski sentinel'in ürün eklemesini engelle.
    disconnectScrollLoader();

    return loadSorted(baseParams())
      .then(function (sorted) {
        // busy paint'ten ÖNCE kapatılıyor: paint yeni sentinel'i kurar ve
        // appendMore busy'yken erken dönüyor — sıra tersse ilk otomatik
        // yükleme kaçar ve liste kullanıcı tekrar kaydırana kadar takılır.
        setBusy(ctx, false);
        if (!state.active) return;
        state.sorted = sorted;
        paint(ctx, 0, Math.min(state.perPage, sorted.length), true);
      })
      .catch(function (error) {
        // Endpoint yoksa/hata verirse sessizce varsayılan sıralamada kal.
        console.warn('[gen78-discount-sort]', (error && error.message) || error);
        setBusy(ctx, false);
        deactivate(ctx);
      });
  }

  /**
   * Sıralamadan çık. Grid'i geri yüklemiyoruz — bunu ya temanın _renderView'ı
   * (native sıralamaya geçildiğinde) ya da sayfa yenilemesi yapıyor.
   */
  function deactivate(ctx) {
    state.active = false;
    state.sorted = null;
    state.shown = 0;
    disconnectScrollLoader();

    var partial = (ctx && ctx.partial) || document.querySelector('[data-partial]');
    if (!partial) return;

    partial.classList.remove('gen78-sorted');

    var holder = partial.querySelector('.gen78-sort-more');
    if (holder) holder.remove();
  }

  function mirrorRadios() {
    var radios = document.querySelectorAll('input[name="sort_by"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = radios[i].value === SORT_VALUE;
    }
  }

  function pushUrl() {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', SORT_VALUE);
    params.delete('page');
    var query = params.toString();
    history.pushState(
      { gen78Sort: true },
      '',
      window.location.pathname + (query ? '?' + query : '')
    );
  }

  function activate(options) {
    var ctx = context();
    if (!ctx) return;

    state.active = true;
    mirrorRadios();
    if (!options || options.push !== false) pushUrl();
    apply(ctx);
  }

  function observe() {
    var ctx = context();
    if (!ctx || !state.observer) return;
    state.observer.observe(ctx.partial, { childList: true, subtree: true });
  }

  /**
   * Tema kendi iç event bus'ını kullanıyor, DOM event yayınlamıyor. Bu yüzden
   * [data-partial] izlenir: filtre değişiminde tema grid'i sunucu sırasıyla
   * yeniden yazar, biz de sıralamayı tekrar uygularız.
   */
  function initObserver() {
    var timer = null;

    state.observer = new MutationObserver(function () {
      // Tema render'dan sonra kendi son işlemlerini de yapıyor (animasyon,
      // ProductItem yeniden kurulumu) — hepsini tek tetiklemede topla.
      clearTimeout(timer);
      timer = setTimeout(function () {
        var ctx = context();
        if (!ctx) return;

        syncCarousels(ctx.grid);
        if (!state.active || state.busy) return;

        // renderFilters drawer'ı sunucudan gelen HTML ile yeniler; radyo
        // durumumuz kaybolabilir.
        mirrorRadios();
        apply(ctx);
      }, 50);
    });

    observe();
  }

  function onSortChange(e) {
    var input = e.target;
    if (!input || input.name !== 'sort_by' || input.type !== 'radio' || !input.checked) return;

    if (input.value === SORT_VALUE) {
      // Temanın change handler'ları bubble fazında; capture'da durdurmak
      // _renderView'ın tetiklenmesini engeller. Formlar arası senkronizasyonu
      // (normalde filter-drawer.liquid içindeki script yapar) biz devralıyoruz.
      e.stopPropagation();
      activate();
      return;
    }

    // Native bir sıralamaya dönüldü: propagation'ı durdurmuyoruz, temanın
    // _renderView'ı sunucu sıralamasını ve normal sayfalamayı geri getiriyor.
    deactivate(context());
  }

  function initSort() {
    var ctx = context();
    if (!ctx) return;

    var section = document.querySelector(
      '[data-section-type="collection"], [data-section-type="search"]'
    );

    // Sunucudan gelen ilk sayfadaki kart sayısı = sayfa başına ürün.
    var perPage = parseInt(
      (section && section.getAttribute('data-collection-items-per-page')) || '',
      10
    );
    if (!(perPage > 0)) perPage = ctx.grid.querySelectorAll('.product-item').length;
    state.perPage = perPage > 0 ? perPage : 24;

    // infinite | click | paginated — "daha fazla" kontrolünün şeklini belirler.
    state.paginationType =
      (section && section.getAttribute('data-pagination-type')) || 'infinite';

    document.addEventListener('change', onSortChange, true);

    window.addEventListener('popstate', function () {
      // Sıralama açık/kapalı durumu değiştiyse en temiz davranış yeniden yükleme;
      // aynı sıralama içindeki filtre gezinmesini observer hallediyor.
      if (urlHasSort() !== state.active) window.location.reload();
    });

    initObserver();

    if (urlHasSort()) activate({ push: false });
  }

  /* ========================================================================= */

  function init() {
    initCarousels();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
